import Lenis from "lenis";

let lenis = null;

export function initSmooth() {
    if (lenis) return lenis;
    lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    const raf = (t) => {
        lenis.raf(t);
        requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return lenis;
}

export function scrollToId(href) {
    const el = document.querySelector(href);
    if (!el) return;
    if (lenis) {
        lenis.scrollTo(el, { offset: -72, duration: 1.3 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
}